export default __webpack_public_path__ + "00d73f8.png";